import { render } from "./TermsOfService.vue?vue&type=template&id=4a1cb18f"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=4a1cb18f&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__